(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initTimeline(root) {
    if (!root || root.getAttribute('data-bm-init') === '1') return;
    root.setAttribute('data-bm-init', '1');

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    var cta = root.querySelector('[data-bm-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
    }

    var zone = root.querySelector('[data-bm-track-zone]');
    var rail = root.querySelector('[data-bm-rail]');
    var fill = root.querySelector('[data-bm-fill]');
    var stages = Array.prototype.slice.call(root.querySelectorAll('[data-bm-stage]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bm-dot]'));
    if (!zone || !rail || !fill || !dots.length) return;

    var anchor = parseFloat(root.getAttribute('data-bm-anchor'));
    if (isNaN(anchor)) anchor = 0.6;

    var railTop = 0;
    var railHeight = 1;
    var offsets = [];

    // Offsets de cada dot (centro) relativos al contenedor del timeline.
    function measure() {
      var base = zone.getBoundingClientRect();
      offsets = dots.map(function (dot) {
        var r = dot.getBoundingClientRect();
        return r.top - base.top + r.height / 2;
      });
      railTop = offsets[0] || 0;
      var last = offsets[offsets.length - 1] || 0;
      railHeight = Math.max(last - railTop, 1);
      rail.style.top = railTop + 'px';
      rail.style.height = railHeight + 'px';
      update();
    }

    function update() {
      var rect = zone.getBoundingClientRect();
      var progress = 0;
      if (rect.height > 0) {
        progress = (window.innerHeight * anchor - rect.top) / rect.height;
      }
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      fill.style.height = (progress * 100) + '%';

      // Frente del progreso: último dot alcanzado por el fill (en px).
      var fillPx = progress * railHeight;
      var frontier = -1;
      for (var i = 0; i < offsets.length; i++) {
        if (fillPx + 0.5 >= offsets[i] - railTop) frontier = i;
      }
      for (var j = 0; j < stages.length; j++) {
        stages[j].classList.toggle('is-active', j === frontier);
        stages[j].classList.toggle('is-passed', j < frontier);
      }
    }

    var ticking = false;
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    var ro = null;
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(function () {
        measure();
      });
      ro.observe(zone);
    } else {
      window.addEventListener('resize', measure);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        measure();
      });
    }

    measure();

    root.bmTimelineDestroy = function () {
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
      window.removeEventListener('resize', measure);
      if (ro) ro.disconnect();
      root.removeAttribute('data-bm-init');
      delete root.bmTimelineDestroy;
    };
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-bm-timeline]');
    Array.prototype.forEach.call(nodes, initTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Editor de temas: re-inicializar al recargar la sección y limpiar al removerla.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var nodes = e.target.querySelectorAll('[data-bm-timeline]');
    Array.prototype.forEach.call(nodes, function (node) {
      if (node.bmTimelineDestroy) node.bmTimelineDestroy();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-vs-brands"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.bmVsBrandsCtaBound) return;
  window.bmVsBrandsCtaBound = true;

  // Delegación global: sobrevive a recargas de sección en el editor
  // sin necesidad de re-inicializar por instancia.
  document.addEventListener('click', function (e) {
    var target = e.target;
    var btn = target && target.closest ? target.closest('[data-bmv-cta-top]') : null;
    if (!btn) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
